import { createFileRoute } from "@tanstack/react-router"
import { ChannelSettingsPage } from "~/components/settings/ChannelSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/channels")({
  component: ChannelSettingsPage,
})
